import { useQuery } from 'react-query';
import { httpRequest } from '../config/api';

export const outputDataService = {
  getOutputData: params =>
    httpRequest.get('api/get-data', {
      params
    })
};

export const useGetOutputData = ({ queryOptions, params } = {}) => {
  // Key namespace was originally 'GET_PERIOD_BY_ID' — same root key used by
  // usePeriodById in period.service.js. React Query treats matching prefixes
  // as the same family for invalidation, so every period mutation invalidated
  // this query and forced a refetch of the heavy /api/get-data payload
  // (and vice versa). Move to a dedicated namespace so the caches no longer
  // collide.
  return useQuery(
    ['GET_OUTPUT_DATA', params],
    () => outputDataService.getOutputData(params),
    queryOptions
  );
};
